import React from "react";
import { getPairMeta, getPairTicker } from "../../pairMeta";
import { FavoriteStarIcon } from "../../../Orders/Community/FavoriteStarIcon";
import { formatChange, formatPrice, parseTicker } from "../utils/ticker";
import downIcon from "@assets/images/icons/arrow-down-red.svg";
import upIcon from "@assets/images/icons/arrow-up-green.svg";

/**
 * One pair in the asset modal: favorite star, coin, price and 24h change.
 *
 * @param {object} props
 * @param {object} props.pair
 * @param {object|undefined} props.ticker — entry from futures tickersMap
 * @param {boolean} props.isFavorite
 * @param {(pair: object) => void} props.onSelect
 * @param {(pair: object) => void} props.onToggleFavorite
 */
export const PairRow = ({
  pair,
  ticker,
  isFavorite,
  onSelect,
  onToggleFavorite,
}) => {
  const meta = getPairMeta(pair.slug);
  const { lastPrice, changePercent } = parseTicker(ticker);
  const isUp = changePercent >= 0;

  return (
    <li className="futures-pairs__row">
      <button
        className="futures-pairs__star"
        type="button"
        aria-pressed={isFavorite}
        aria-label="Favorite"
        onClick={() => onToggleFavorite(pair)}
      >
        <FavoriteStarIcon active={isFavorite} size={20} />
      </button>

      <button
        className="futures-pairs__row-btn"
        type="button"
        onClick={() => onSelect(pair)}
      >
        <span className="futures-pairs__coin">
          <img className="futures-pairs__coin-icon" src={meta?.icon} alt="" />
          <span className="futures-pairs__coin-names">
            <span className="futures-pairs__coin-ticker">
              {getPairTicker(pair.slug) || pair.name}
            </span>
            {meta?.fullName && (
              <span className="futures-pairs__coin-name">{meta.fullName}</span>
            )}
          </span>
        </span>

        <span className="futures-pairs__quote">
          <span className="futures-pairs__price">{formatPrice(lastPrice)}</span>

          {changePercent !== null && (
            <span
              className={`futures-pairs__change futures-pairs__change--${
                isUp ? "up" : "down"
              }`}
            >
              {formatChange(changePercent)}
              <img src={isUp ? upIcon : downIcon} alt="" />
            </span>
          )}
        </span>
      </button>
    </li>
  );
};
